import { FormattedMessage } from 'react-intl';
import Task from '../../../../../handlers/Event/Task';
import { CountersPart } from './Parts/CountersPart';

type Props = {
    task: Task;
};

export const LPSensorUnforceColor = (props: Props) => {
    return (
        <>
            <FormattedMessage id="tasks.disableForceLPSensorColor" />

            <CountersPart counters={props.task.getCounters()} />
        </>
    );
};
